module.exports = __webpack_public_path__ + "12f36eed83fdf6fa33bccb7eae18286a.svg";